module.exports = __webpack_public_path__ + "img/no_cam.5d92f4a8.svg";